import {BaseAppPrefs} from "../shared/BaseAppPrefs";

export abstract class BaseFyneAIAppPrefs extends BaseAppPrefs {

  static readonly PREF_LOCK_PIN = "lock_pin";
  static readonly PREF_LOCKED = "locked";
  static readonly PREF_SELECTED_RESOURCE_ID = "sel_res_id";

  protected constructor() {
    super();
  }

  getSelectedResourceId(): string | null {
    return this.prefs.getString(BaseFyneAIAppPrefs.PREF_SELECTED_RESOURCE_ID);
  }

  setSelectedResourceId(id: string): void {
    this.prefs.setString(BaseFyneAIAppPrefs.PREF_SELECTED_RESOURCE_ID, id);
  }

  isLocked() {
    return this.prefs.getBoolean(BaseFyneAIAppPrefs.PREF_LOCKED);
  }

  setLocked(locked: boolean) {
    this.prefs.setBoolean(BaseFyneAIAppPrefs.PREF_LOCKED, locked);
    this.notify(BaseFyneAIAppPrefs.PREF_LOCKED);
  }

  getLockPin() {
    return this.prefs.getString(BaseFyneAIAppPrefs.PREF_LOCK_PIN);
  }

  setLockPin(lockPin: string) {
    this.prefs.setString(BaseFyneAIAppPrefs.PREF_LOCK_PIN, lockPin);
    this.notify(BaseFyneAIAppPrefs.PREF_LOCK_PIN);
  }
}
